<template>
   <el-dialog
      :title="textTile[dialogFlag]"
      :visible.sync="visibleChange"
      :append-to-body="true"
      :close-on-click-modal="false"
      :before-close="cancelClose"
      :destroy-on-close="true"
      width="800px">
      <el-form
        :model="form"
        :rules="editRules"
        label-width="120px"
        ref="hForm">
        <el-form-item
          label="用水编号"
          prop="USER_NO">
          <el-input
            v-model="form.USER_NO"
            maxlength="11"
            placeholder="请输入您的用水编号"
            show-word-limit
            :readonly="dialogFlag === this.CONSTAPP.CTRL_FLAG.SHOW"
            :clearable="true"/>
        </el-form-item>
        <el-form-item
          label="原用户名"
          prop="USER_OLDNM">
          <el-input
            v-model="form.USER_OLDNM"
            maxlength="64"
            placeholder="请输入过户用水编号的原用户名称"
            show-word-limit
            :readonly="dialogFlag === this.CONSTAPP.CTRL_FLAG.SHOW"
            :clearable="true"/>
        </el-form-item>
        <el-form-item
          label="新用户名"
          prop="USER_NAME">
          <el-input
            v-model="form.USER_NAME"
            maxlength="64"
            placeholder="请输入过户用水编号的新用户名称"
            show-word-limit
            :readonly="dialogFlag === this.CONSTAPP.CTRL_FLAG.SHOW"
            :clearable="true"/>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="USER_PHONE">
          <el-input
            v-model="form.USER_PHONE"
            maxlength="11"
            placeholder="请输入您的联系手机或电话"
            show-word-limit
            :readonly="dialogFlag === this.CONSTAPP.CTRL_FLAG.SHOW"
            :clearable="true"/>
        </el-form-item>
        <el-form-item
          label="过户原因"
           prop="DO_DATA">
          <el-input
            v-model="form.DO_DATA"
            maxlength="252"
            placeholder="请输入您报装的用户地址"
            show-word-limit
            type="textarea"
            rows="2"
            :readonly="dialogFlag === this.CONSTAPP.CTRL_FLAG.SHOW"
            :clearable="true"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="dialogFlag === this.CONSTAPP.CTRL_FLAG.SHOW"
          @click="cancelClose"
          type="info"
          size="medium">关闭</el-button>
        <el-button
          v-else
          @click="cancelClose"
          type="info"
          size="medium">取消</el-button>
        <el-button
          v-if="dialogFlag === this.CONSTAPP.CTRL_FLAG.CREATE"
          type="primary"
          :loading="dialogLoading"
          @click="createDone"
          size="medium">确定</el-button>
      </div>
    </el-dialog>
</template>

<script>
import util from '@/utils/util'
import { doUserRegAdd } from '@/api/Hall/xagl'

export default {
  props: {
    loading: {
      default: false
    },
    visible: {}
  },
  data() {
    return {
      dialogLoading: false,
      dialogFlag: '',
      textTile: {
        [this.CONSTAPP.CTRL_FLAG.SHOW]: '用户过户工单信息',
        [this.CONSTAPP.CTRL_FLAG.CREATE]: '新增用户过户工单信息'
      },
      form: {
        ID_TYPE:'2',
        USER_NO: undefined,
        USER_OLDNM: undefined,
        USER_NAME: undefined,
        USER_PHONE: undefined,
        USER_ADDR: undefined,
        DO_DATA: undefined
      },
      editRules: {
        USER_NO: [
          {
            required: true,
            message: '您的用水编号不能为空',
            trigger: 'blur'
          }
        ],
        USER_OLDNM: [
          {
            required: true,
            message: '原名称不能为空',
            trigger: 'blur'
          }
        ],
        USER_NAME: [
          {
            required: true,
            message: '新名称不能为空',
            trigger: 'blur'
          }
        ],
        USER_PHONE: [
          {
            required: true,
            message: '您的联系手机或电话不能为空',
            trigger: 'blur'
          }
        ],
        DO_DATA: [
          {
            required: true,
            message: '过户原因必须输入',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    visibleChange: {
      get: function() {
        return this.visible
      },
      // 子组件参数变动需通过此方法传递到父组件进行数据更新
      set: function(newValue) {
        this.$emit('on-visible', newValue)
      }
    }
  },
  methods: {
    cancelClose() {
      this.activeNames = []
      this.$parent.dialogVisible = false
    },
    init(flag, rcdData) {
      this.dialogFlag = flag
      this.curModel = undefined
      this.$refs.hForm.clearValidate()
    },
    // 请求创建
    createDone() {
      this.$refs.hForm.validate(valid => {
        if (valid) {
          this.dialogLoading = true
          doUserRegAdd(this.form)
            .then(res => {
              console.log('res', res)
              this.$parent.dialogVisible = false
              if ( res.sure === 'Y') {
                  this.$Hmessage(0, '用水过户申请成功!后继可用申请编号'+res.data+'查询处理状态')
                  this.finished = true;
              } else {
                    this.$Hmessage(1, res.info)
              }
            })
            .catch(error => {
              console.log('ERROR:', error)
            })
            .finally(() => {
              this.dialogLoading = false
            })
        }
      })
    },
    // 请求编辑
    updateDone() {
      console.log('in update')
      this.$refs.hForm.validate(valid => {
        if (valid) {
          this.dialogLoading = true
          updateDeviceRcd(this.form)
            .then(res => {
              this.$parent.dialogFormVisible = false
              this.$emit('on-refresh-table', false)
              this.$Hmessage(0, '操作成功')
            })
            .catch(error => {
              console.log('ERROR:', error)
            })
            .finally(() => {
              this.dialogLoading = false
            })
        } else {
          console.log('ERROR CHECK')
        }
      })
    }
  }
}
</script>

<style >
.el-dialog{
  margin:0!important;
  display:flex;
  flex-direction:column;
   max-height:calc(100% - 30px);
   max-width:calc(100% - 30px);
}
.el-dialog__body{
  transform: translate3d(0,0,0);
  overflow:auto;
}
.el-dialog__header {
  padding: 10px 10px 10px 10px!important;
  border-bottom: 1px solid #bbb8b8;
  background-color: #F1F5F8
}
.el-dialog__footer {
  text-align: center!important;
  padding: 12px 20px 12px 20px!important;
  border-top: 1px solid #bbb8b8;
}
/* .el-dialog__headerbtn {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 24px!important;
} */
.el-dialog__wrapper {
  display:flex;
  justify-content: center;
  align-items:center;
}
.el-collapse-item__header {
  background-color: #F1F5F8;
  padding-left: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
</style>
